import { bootstrapApplication, createApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { createCustomElement } from '@angular/elements'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { KanbanModule } from './app/_pages/kanban/kanban.module'
import { environment } from './environments/environment'

if (environment.local) {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err))
  } else {
    platformBrowserDynamic()
    .bootstrapModule(KanbanModule)
    .catch(err => console.error(err))
}
